import styled from 'styled-components'

export const ElementVantagensWhite = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 85vh;

  @media (max-width: 983px) {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column-reverse;
    gap: 5rem;
  }

  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 768px) {
    width: 750px;
  }

  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1200px) {
    width: 1170px;
  }

  .imgsGroup {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .titleGroup {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.25rem;
  }

  .descricaoGroup {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  .imgLine {
    display: flex;
    align-items: center;
    gap: 1rem;

    img {
      max-width: 125px;
      border-radius: 50%;
    }
    @media (max-width: 983px) {
      img {
        max-width: 115px;
      }
    }

    @media (max-width: 397px) {
      img {
        display: none;
      }
    }
  }
`

export const Title = styled.div`
  font-size: 4rem;
  font-weight: 900;
  color: var(--purple);
  @media (max-width: 655px) {
    font-size: 3rem;
  }
`

export const SubTitle = styled.div`
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--orange);
`
